<template>
  <div class="w-100 px-5 py-4">
    <div id="TituloSalaVirtual_div" class="w-100">
      <h1>SALA VIRTUAL</h1>
      <h3>Descarga de la audiencias</h3>
    </div>
    <div class="row d-flex">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 padding-div-low">
        <div class="area">
          <h4>Ingrese el token para descargar la audiencia</h4>
          <hr />
          <h6>Token de la audiencia</h6>
          <input placeholder="Escriba o pegue el token otorgado" v-model="token" class="form-control" id="token" />
          <br />
          <div class="text-right">
            <button class="btn btn-default" v-on:click="descargaLaAudienciaPorMedioDelToken()"><i class="fas fa-file-download"></i>&nbsp;&nbsp;Consulta token</button>
          </div>
        </div>
      </div>      
    </div>
  </div>
</template>

<script>
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import enumeraciones from '@/../static/js/enumeraciones'
  import router from '@/router/index'
  //import { param } from 'jquery'

  export default {
    components: {
      enumeraciones,
     // Reproductor: sistemas.Forseti.Reproductor
      
    },
    data() {
      return {
        token: "",
        Audiencia:{

        },
        AudienciaId:""

      }
    },
    components: {
      
    },
    methods: {
      crearLaDescargaDelReproductor: function(){
        return '<button class="btn btn-default" onclick="location.href=\'' + api.conexion + api.Comun.funcion.DescargarArchivo + '?rutaDelArchivo=\\Forseti\Instaladores\Forseti.exe"><i class="fab fa-windows"></i>&nbsp;&nbsp;Windows (x86)</button>&nbsp;&nbsp;';
          //'<button class="btn btn-default" onclick="location.href=\'' + api.conexion + api.Comun.funcion.DescargarArchivo + '?rutaDelArchivo=\\Forseti\Instaladores\Forseti.pkg"><i class="fas fa-apple-alt"></i>&nbsp;&nbsp;MAC</button>';
      },
      descargaLaAudienciaPorMedioDelToken: function(){
           console.log("iniciar descargaLaAudienciaPorMedioDelToken");

           let peticion = {
             Token: this.token
           }
        if(this.token == "") {
          comun.mensajeDeAlerta("Ingresé el token otorgado para poder continuar", null, null);
        } else {
          
           axios.post(
            api.conexion + api.Forseti.sistema.consultas.salavirtual.DescargarAudiencia, peticion,
          comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)
            ).then( respuesta => {
              if(respuesta.data.SiHayError){
               comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
              }else{
                this.Audiencia= respuesta.data.Audiencia;
                router.push({ name: 'ReproducirAudiencia', params: { AudienciaId:this.Audiencia.AudienciaId}})
              }
            }).catch(excepcion => {
          console.log(excepcion);
          comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
          comun.SeEstaCargandoInformacion(false);
        });
        }
      }
      /*,
      descargaInstalador: function(esWindows) {
        if(esWindows)
          window.open(api.conexion + api.Comun.funcion.DescargarArchivo + "?rutaDelArchivo=\\\\Forseti\\Instaladores\\Forseti.exe", '_blank');
        else
          window.open(api.conexion + api.Comun.funcion.DescargarArchivo + "?rutaDelArchivo=\\\\Forseti\\Instaladores\\Forseti.pkg", '_blank');
      }*/
    }
  }

</script>

<style>
  .padding-div-low {
    padding-top: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Forseti/Consultas/SalaVirtual/SalaVirtual.vue